<template>
  <div class="product-container">
    <!-- <nav class="nav-header">
        <p @click="$router.push({name: 'system-admin-dids-all-dids'})"
            :class="($route.name === 'system-admin-dids-all-dids' 
              || $route.name === 'system-admin-dids-import-did' 
              || $route.name === 'system-admin-dids-add-did'
              || $route.name === 'system-admin-dids-edit-did') ? 'active' : ''">All DIDs</p>
        <p @click="$router.push({name: 'company-admin-dids-all-call-flows'})"
            :class="($route.name === 'company-admin-dids-all-call-flows') ? 'active' : ''">All Callflows</p>
        <p @click="$router.push({name: 'system-admin-dids-all-suppressions'})"
            :class="($route.name === 'system-admin-dids-all-suppressions') ? 'active' : ''">Suppression</p>
    </nav>-->
    <router-view class="router-container" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 10px 0px 10px;
    display: flex;
    p {
      cursor: pointer;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      padding: 0px 5px 0px 5px;
      margin-right: 10px;
      color: #bdbfd8;
      font-family: "" Helvetica Neue "";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
  .router-container {
    padding: 0 20px;
  }
}
</style>

